<template>
  <form name="questionForm" @submit.prevent="send">
    <fieldset :disabled="sending">
      <div class="row">
        <div class="col-12 col-md">
          <div class="form-group">
            <input type="text" name="name" id="name" v-model="name" class="form-control" placeholder="Enter your email">
          </div>
        </div>

        <div class="col-12 col-md">
          <div class="form-group">
            <textarea type="text" name="question" id="question" v-model="question" class="form-control" placeholder="Enter your question" rows="5"></textarea>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <div class="mr-4 text-success" v-if="result">
          {{ result }}
        </div>
        <button type="submit" name="send" id="send" class="btn btn-sm btn-secondary" :disabled="!this.formValid">Send</button>
      </div>
    </fieldset>
  </form>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "qna-form",
    props: {
      eventId: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        sending: false,
        name: null,
        question: null,
        result: null,
      }
    },
    computed: {
      formValid() {
        return !this.sending &&  (this.name && this.name.length > 0) && (this.question && this.question.length > 0)
      },
    },
    methods: {
      async send() {
        if(!this.formValid) { return false }
        this.sending = true

        await firebase.firestore().collection(`questions`).add({
          name: this.name,
          question: this.question,
          eventId: this.eventId,
          created: firebase.firestore.FieldValue.serverTimestamp()
        })

        this.question = null
        this.result = "Thank you for your question!"
        this.sending = false

        setTimeout(() => {
          this.result = null
        }, 2000)
      }
    }
  }
</script>